// removed by extract-text-webpack-plugin
module.exports = {"loginPage":"hInwrYG7pnxqbvKJmnmJu","header":"vzUn2Qfr7f9Xr32g3GODJ","loginForm":"ROGqVHkcXr8KCrEKMp8-8","textCenter":"_3eoH4V_PO0r0_dSXoLJEM_"};


//////////////////
// WEBPACK FOOTER
// ./src/components/LoginForm/LoginForm.scss
// module id = 791
// module chunks = 0